import { FC, forwardRef } from 'react'
import { styled } from '@mui/material/styles'
import classNames from 'classnames'
import { Box } from '@mui/material'

export interface IAttributeProps {
    className?: string
    orientation?: 'horizontal' | 'vertical'
    sx?: object
    children?: React.ReactNode
}
// TODO: Will remove this onc ewe start sending sx instead of classname for all pages

const AttributeWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: '0.224rem 0 0.8rem 0',

    // If an AttributeWrapper is the first-child in it's parent, and it also has a sibling that is also an AttributeWrapper, add this styling
    '&:first-child:has(+ &)': {
        paddingTop: '0.8rem',
    },
}))

export const Attribute: FC<IAttributeProps> = forwardRef((props, ref: any) => {
    return (
        <AttributeWrapper
            className={classNames(props.className)}
            ref={ref}
            sx={{
                flexDirection:
                    props.orientation === 'vertical' ? 'column' : 'row',
                ...(props.sx && props.sx),
            }}
        >
            {props.children}
        </AttributeWrapper>
    )
})

Attribute.defaultProps = {
    orientation: 'vertical',
}

export * from './AttributeLabel'
export * from './AttributeValue'
